import React from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSchemaProps {
  faqs: FAQItem[];
  title?: string;
}

const FAQSchema: React.FC<FAQSchemaProps> = ({ faqs, title = "Frequently Asked Questions" }) => {
  React.useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      name: title,
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer
        }
      }))
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.textContent = JSON.stringify(schema);
    document.head.appendChild(scriptTag);

    return () => {
      try {
        document.head.removeChild(scriptTag);
      } catch (e) {
        // Element may have already been removed
      }
    };
  }, [faqs, title]);

  return null; // This component only adds schema markup, no visual elements
};

export default FAQSchema;